<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.searchKey"
              @keyup.enter="clickQuery"
              type="search"
              placeholder="输入关键字快速搜索..."
              size="sm"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="visible = !visible"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="clickQuery">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <!-- 头部按钮 -->
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="fromLoad('add')"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="printTag('print')"
              v-if="allow('P')"
            >
              <b-icon-tag></b-icon-tag>
              {{ $l('INDEX.btn_print_tag') || '标签打印' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="visible"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="150px">
        <el-row :gutter="20">
          <el-form-item :label="$l('table_label_fabric_no') || '面料编号'"
            ><el-col :span="24">
              <el-input
                style="width:100%;"
                clearable
                size="small"
                v-model="form.fabricNo"
                :placeholder="$l('table_label_fabric_no') || '面料编号'"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item :label="$l('table_label_fabric_name') || '面料名称'"
            ><el-col :span="24">
              <el-input
                style="width:100%;"
                clearable
                size="small"
                v-model="form.fabricName"
                :placeholder="$l('table_label_fabric_name') || '面料名称'"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item :label="$l('table_label_fabric_color_no') || '颜色编号'"
            ><el-col :span="24">
              <el-input
                style="width:100%;"
                clearable
                size="small"
                v-model="form.fabricColorNo"
                :placeholder="$l('table_label_fabric_color_no') || '颜色编号'"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item
            :label="$l('table_label_fabric_color_title') || '颜色名称'"
            ><el-col :span="24">
              <el-input
                style="width:100%;"
                clearable
                size="small"
                v-model="form.fabricColorTitle"
                :placeholder="
                  $l('table_label_fabric_color_title') || '颜色名称'
                "
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item :label="$l('form_label_bill_no') || '业务单据编号'"
            ><el-col :span="24">
              <el-input
                style="width:100%;"
                clearable
                size="small"
                v-model="form.modifyBillNo"
                :placeholder="$l('form_label_bill_no') || '业务单据编号'"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item :label="$l('table_label_logTime') || '日志时间'">
            <el-col :span="11">
              <el-date-picker
                v-model="form.logTimeStart"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date' || '选择日期')"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                v-model="form.logTimeEnd"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date' || '选择日期')"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消查询</el-button>
        <el-button size="small" type="warning" @click="onReset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="clickQuery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      dialogVisible: false,
      form: {
        searchKey: '',
        fabricNo: '',
        fabricName: '',
        fabricColorNo: '',
        fabricColorTitle: '',
        modifyBillNo: '',
        logTimeStart: '',
        logTimeEnd: ''
      }
    }
  },
  mounted() {
    this.onReset()
  },
  activated() {},
  methods: {
    clickQuery() {
      this.$emit('reset')
      this.query()
    },
    closeDialog() {
      this.visible = false
    },
    query() {
      this.$emit('submit', this.form)
      this.visible = false
    },
    onReset() {
      this.form = {}
      this.clickQuery()
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
